module.exports = __webpack_public_path__ + "static/media/nurse_ipad_reception.179ed637.png";